import _t from 'i18n!nls/product-card';

export type MarketingTagCategory =
  'job-ready' | 'job-skills' | 'bestseller' | 'top-ai-program' | 'trending-now' | 'recently-updated';

export type MarketingStatusTag = {
  tag: string;
  tagName: string;
  category: MarketingTagCategory;
};

type MarketingTagSlugList = readonly [MarketingTagCategory, readonly string[]];

const JOB_READY_SLUGS: readonly string[] = [
  'aapc-medical-biller',
  'agile-atlassian-jira',
  'applied-data-science',
  'aws-cloud-solutions-architect',
  'aws-cloud-support-associate',
  'ba-liberal-studies-georgetown',
  'bach-information-technology-illinois-tech',
  'bachelor-of-science-computer-science-bits',
  'bachelor-of-science-computer-science-london',
  'bachelor-of-science-data-science-ai-iitguwahati',
  'bachelor-of-science-general-business-unt',
  'bachelor-of-science-psychology-jgu',
  'bsc-business-administration-london',
  'bsc-data-science-huddersfield',
  'bsc-marketing-london',
  'cloud-engineering-gcp',
  'emba-iitr',
  'ifp-computer-science-london',
  'imba',
  'imsa',
  'johns-hopkins-medical-office-manager',
  'ma-international-relations-security-strategy-jgu',
  'ma-public-policy-jgu',
  'mas-data-science-illinois-tech',
  'mas-engineering-berkeley',
  'mas-information-technology-illinois-tech',
  'master-computer-science-clemson',
  'master-of-data-science-university-of-pittsburgh',
  'master-of-science-data-science-boulder',
  'masters-in-computer-data-science',
  'mba-business-analytics-jgu',
  'mba-illinois-tech',
  'me-engineering-management-boulder',
  'meng-computer-engineering-dartmouth',
  'ms-artificial-intelligence-boulder',
  'ms-computer-science-ball-state',
  'ms-computer-science-boulder',
  'ms-data-analytics-engineering-northeastern',
  'ms-data-science-ball-state',
  'ms-engineering-management-northeastern',
  'ms-management-illinois',
  'msc-computer-science-heriot-watt',
  'msc-cyber-security-london',
  'msc-data-science-ul',
  'msc-management-huddersfield',
  'msee-boulder',
  'omie',
  'packt-cisco-ccna-200-301-the-complete-guide-to-getting-certified',
  'unt-online-bachelor-completion',
];

const JOB_SKILLS_SLUGS: readonly string[] = [
  'ai-machinelearning-essentials',
  'aws-cloud-technical-essentials',
  'c-programming',
  'data-engineering',
  'data-skills-for-excel',
  'design-develop-and-deploy-multi-agent-systems-with-crewai',
  'excel-data-analytics-visualization',
  'fast-prototyping-of-genai-apps-with-streamlit',
  'finance-quantitative-modeling-analysts',
  'gemini-for-developers',
  'gis-mapping-spatial-analysis',
  'google-cloud-cybersecurity-certificate',
  'health-informatics',
  'ibm-digital-marketing-and-growth-hacking',
  'ibm-product-owner',
  'ibm-program-manager',
  'ibm-systems-analyst',
  'microsoft-data-architecture-for-modern-data-stacks',
  'packt-docker-and-kubernetes-masterclass-from-beginner-to-advanced',
  'unlock-business-insights-with-microsoft-excel-and-power-bi',
  'uol-business-and-marketing-strategies',
];

const BESTSELLER_SLUGS: readonly string[] = [
  'adp-payroll-specialist',
  'data-science-foundations',
  'data-science-fundamentals-python-sql',
  'decentralized-finance-duke',
  'google-agile-essentials',
  'google-data-analysis-with-python',
  'google-people-management-essentials',
  'ibm-data-analyst-r-excel',
  'jhu-data-science',
  'learn-korean',
  'microsoft-data-visualization',
  'pearson-pmp-certification',
  'programming-python-java',
  'retrieval-augmented-generation-rag',
  'sales-development-representative',
  'software-engineering-fundamentals',
  'statistical-inference-for-data-science-applications',
  'wharton-success',
];

const TOP_AI_PROGRAM_SLUGS: readonly string[] = [
  'google-ai',
  'ai-essentials-google',
  'machine-learning-introduction',
  'ibm-generative-ai-engineering',
  'ai-healthcare',
  'ibm-rag-and-agentic-ai',
  'deep-learning',
  'ai-for-business-wharton',
  'prompting-essentials-google',
  'ai-engineer',
  'applied-artifical-intelligence-ibm-watson-ai',
  'ai-for-everyone',
  'microsoft-ai-product-manager',
  'ibm-ai-product-manager',
  'microsoft-sql-server',
  'prompt-engineering',
  'microsoft-ai-and-ml-engineering',
  'ibm-machine-learning',
  'introduction-to-generative-ai',
  'ai-foundations-for-everyone',
  'ai-foundations-business-professionals',
  'real-world-ai-for-everyone',
  'generative-ai-software-engineering',
  'ai-product-management-duke',
  'microsoft-365-copilot-for-productivity',
  'financialengineering',
  'aws-gen-ai-developer-advanced',
  'ai-agents-for-leaders',
  'ai-agents',
  'complete-claude-code-claude-cowork-masterclass',
  'claude-ai-tools-for-beginners',
  'generative-ai-for-software-development',
  'pytorch-for-deep-learning',
  'introduction-data-science',
  'ai-automation-engineer-n8n',
  'microsoft-generative-ai-engineering',
  'natural-language-processing',
  'build-anything-with-ai',
  'ai-financial-services-foundations-future-trends',
  'generative-ai-with-llms',
  'chatgpt-free-ai-tools-to-excel',
  'machine-learning-specialization',
  'generative-ai-engineering-with-llms',
  'microsoft-enterprise-ai-governance-ethics-and-security',
  'microsoft-genai-for-data-analysis',
  'ibm-deep-learning-with-pytorch-keras-tensorflow',
  'ai-for-medicine',
  'financialtechnology',
  'reinforcement-learning',
  'generative-ai-for-project-managers',
  'microsoft-copilot-your-everyday-ai-companion',
  'vibe-coding',
  'responsible-generative-ai',
  'mastering-claude-ai-prompting-apis-rag-and-mcp',
  'generative-ai-for-executives-and-business-leaders',
  'gemini-for-google-workspace',
  'generative-ai-for-software-developers',
  'tensorflow-in-practice',
  'generative-ai-for-human-resources',
  'google-ai-fundamentals',
  'computational-neuroscience',
  'microsoft-azure-ai-900-ai-fundamentals',
  'generative-ai-for-ui-ux-design',
  'aws-generative-ai-developers',
  'microsoft-ai-agents',
  'smarter-content-and-communications-with-microsoft-copilot',
  'large-language-model-operations',
  'ai-agents-python',
  'preparing-for-google-cloud-machine-learning-engineer-professional-certificate',
  'introduction-to-ai',
  'microsoft-powerbi-developer-and-architect',
  'organizational-strategy-generative-ai',
  'enterprise-ai-data-engineering-databricks',
];

const TRENDING_NOW_SLUGS: readonly string[] = [
  'facebook-social-media-marketing',
  'microsoft-junior-qa-software-tester',
  'microsoft-business-analyst',
  'american-english-pronunciation',
  'getting-started-with-google-workspace',
  'indigenous-canada',
  'introduction-to-business-strategy',
  'ibm-data-engineer',
  'intuit-bookkeeping',
  'sap-business-analyst',
  'social-impact-and-public-policy',
  'technical-support-fundamentals',
  'master-microsoft-office-365-power-platform',
  'sales-development-representative',
  'adp-payroll-specialist',
  'anxiety-mood-substance-addictive-behaviors',
  'ibm-cybersecurity-analyst',
  'pmp-exam-prep-certification-training',
  'meta-front-end-developer',
  'boost-your-leadership-impact',
  'regulatory-compliance',
  'foundations-of-cybersecurity',
  'xlpbi',
  'foundations-data',
  'foundations-of-digital-marketing-and-e-commerce',
  'good-with-words',
  'construction-management',
  'keller-williams-real-estate-agent',
  'adp-compensation-benefits-analyst',
  'ibm-business-analyst-professional-certificate',
  'microsoft-ai-business-professional',
  'mafash',
  'creative-design-tools-adobe-photoshop-illustrator-acrobat',
  'ace-health-coach',
  'meem-project-management',
  'ibm-applied-devops-engineering',
  'ibm-financial-planning-analysis-ai-skills',
  'leading-teams',
  'pearson-certified-associate-in-project-management-capm-exam',
  'aws-fundamentals',
  'microsoft-full-stack-developer',
  'introduction-to-cosmetic-science',
  'marketing-mix',
  'sap-technology-consultant',
  'microsoft-front-end-developer',
  'project-management-foundations',
  'clinical-trials-good-clinical-practice',
  'hrci-human-resources-professional',
  'ask-questions-make-decisions',
  'six-sigma-green-belt',
  'intermediate-grammar',
  'os-power-user',
  'excel-essentials',
  'java-developer',
  'ibm-full-stack-javascript-developer',
  'human-resource-management',
  'cvshealth-call-center-customer-service',
  'ibm-data-analyst-r-excel',
  'meta-full-stack-developer',
  'certificado-de-carrera-de-google-marketing-digital-e-e-commerce',
  'microsoft-power-bi-data-analyst',
  'preparing-data-for-analysis-with-microsoft-excel',
  'ibm-project-manager',
  'rust-programming',
  'learn-sql-basics-data-science',
  'python-for-applied-data-science-ai',
  'negotiation',
  'learn-english-beginning-grammar',
  'medicalterminology',
  'data-analysis-visualization-foundations',
  'psychological-research',
  'ibm-relational-database-administrator',
  'graphic-design',
  'packt-comptia-security-plus-certification-sy0-701-the-total-course',
  'ibm-ui-ux-designer',
  'computer-networking',
  'foundations-user-experience-design',
  'introduction-to-leadership-principles',
  'ibm-it-project-manager',
  'microsoft-excel-skills',
  'microsoft-data-analysis-sql-excel-powerbi',
  'generative-ai-for-leaders',
  'building-ai-agents-and-agentic-workflows',
  'generative-ai-for-everyone',
  'generative-ai-strategic-leader',
  'generative-ai-for-growth-marketing',
  'ai-governance-iso42001-readiness-grc-audit-legal',
  'microsoft-365-copilot',
  'mlops-machine-learning-duke',
  'microsoft-ai-transformation-leader',
];

const RECENTLY_UPDATED_SLUGS: readonly string[] = [
  'data-analytics',
  'google-cloud-data-analytics-certificate',
  'microsoft-program-management',
  'aws-cloud-technology-consultant',
  'meta-android-developer',
  'matlab-programming-engineers-scientists',
  'operations-research',
  'ai-builder',
  'computer-vision-cu',
  'snowflake-generative-ai',
  'digital-healthcare-informatics-and-ai',
  'aws-certified-ai-practitioner',
  'foundations-reinforcement-learning',
  'business-analytics-with-excel',
  'aws-generative-ai-applications',
  'edge-ai-mcu',
  'ai-in-law-research-risk-and-legal-drafting',
  'github',
  'artificial-intelligence-ethics',
  'genai-for-project-management',
  'microsoft-generative-and-agentic-ai-basics',
  'genai-for-business-process-automation',
  'ai-powered-customer-success',
  'applied-ai',
  'machine-learning-scikit-learn-pytorch-hugging-face',
  'packt-langchain-and-langgraph',
  'ai-powered-finance-forecasting-planning-and-reporting',
  'ai-for-hr',
  'ai-engineering',
  'create-and-enhance-visuals-with-ai',
  'build-genai-applications-and-agents',
  'photoshop-image-editing-compositing-and-ai',
  'oracle-cloud-and-ai',
  'data-science-beyond-the-basics-ml-and-ds',
  'microsoft-data-analysis-python-r',
  'ai-for-sales',
  'aimachinelearninginfinance',
  'google-data-analytics',
  'google-cybersecurity',
  'google-it-support',
  'google-digital-marketing-ecommerce',
  'google-ux-design',
  'ibm-data-analyst',
  'hrci-human-resource-associate',
  'ibm-full-stack-cloud-developer',
  'microsoft-it-support-specialist',
  'microsoft-cybersecurity-analyst',
  'microsoft-python-developer',
  'devops-and-software-engineering',
  'salesforce-sales-operations',
  'tableau-business-intelligence-analyst',
  'ibm-product-manager',
  'meta-back-end-developer',
  'microsoft-back-end-developer',
  'microsoft-project-management',
  'ibm-data-manager',
  'unilever-supply-chain-data-analyst',
  'bi-analyst',
  'facebook-marketing-analytics',
  'epic-games-game-design-professional-certificate',
  'meta-data-analyst',
  'amazon-junior-software-developer',
  'meta-database-engineer',
  'microsoft-public-relations',
  'ibm-data-science',
  'adobe-graphic-designer',
  'adobe-content-creator',
  'adobe-marketing-specialist',
  'google-advanced-data-analytics',
  'ibm-isc2-cybersecurity-specialist',
  'unilever-digital-marketing-analyst',
  'backend-javascript-developer',
  'fractal-data-science',
  'xbox-product-manager',
  'ibm-backend-development',
  'support-informatique-google',
  'generative-ai-educators',
  'ibm-ios-android-mobile-app-developer-pc',
  'meta-ios-developer',
  'tally-bookkeeper',
];

// Program list as of August 2026
// @see https://docs.google.com/spreadsheets/d/1ii3J_KcVG1yYS-Jjx3zHyU0oC_fGY6INHq5Sh-XUwkk
export const MARKETING_TAG_SLUG_LISTS: readonly MarketingTagSlugList[] = [
  ['job-ready', JOB_READY_SLUGS],
  ['job-skills', JOB_SKILLS_SLUGS],
  ['bestseller', BESTSELLER_SLUGS],
  ['trending-now', TRENDING_NOW_SLUGS],
  ['top-ai-program', TOP_AI_PROGRAM_SLUGS],
  ['recently-updated', RECENTLY_UPDATED_SLUGS],
];

export const buildMarketingTagSlugMap = (
  lists: readonly MarketingTagSlugList[]
): {
  map: Record<string, MarketingTagCategory>;
  collisions: Array<{ slug: string; from: MarketingTagCategory; to: MarketingTagCategory }>;
} => {
  const map: Record<string, MarketingTagCategory> = {};
  const collisions: Array<{ slug: string; from: MarketingTagCategory; to: MarketingTagCategory }> = [];

  for (const [category, slugs] of lists) {
    for (const slug of slugs) {
      const existing = map[slug];
      if (existing && existing !== category) {
        collisions.push({ slug, from: existing, to: category });
      }
      map[slug] = category;
    }
  }

  return { map, collisions };
};

let marketingTagSlugMap: Record<string, MarketingTagCategory> | undefined;

const getMarketingTagSlugMap = (): Record<string, MarketingTagCategory> => {
  if (!marketingTagSlugMap) {
    // build a map if not cached
    marketingTagSlugMap = buildMarketingTagSlugMap(MARKETING_TAG_SLUG_LISTS).map;
  }
  return marketingTagSlugMap;
};

// Shared tag category colors. Values from the approved design.
export const topAiProgramColors = {
  backgroundColor: 'var(--cds-color-purple-100)',
  color: 'var(--cds-color-purple-950)',
};

export const recentlyUpdatedColors = {
  backgroundColor: 'var(--cds-color-feedback-background-success-weak)',
  color: 'var(--cds-color-feedback-success-hover)',
};

export const trendingNowColors = {
  backgroundColor: 'var(--cds-color-red-100)',
  color: 'var(--cds-color-red-850)',
};

// tagName is kept as the pre-existing, stable analytics identifier for each category — it does
// not follow display-text casing changes, so tracking stays continuous with historical data.
const getMarketingTagContent = (category?: MarketingTagCategory): MarketingStatusTag | undefined => {
  switch (category) {
    case 'job-ready':
      return { tag: _t('Job ready'), tagName: 'Job Ready', category };
    case 'job-skills':
      return { tag: _t('Job skills'), tagName: 'Job Skills', category };
    case 'bestseller':
      return { tag: _t('Bestseller'), tagName: 'Bestseller', category };
    case 'top-ai-program':
      return { tag: _t('Top AI program'), tagName: 'Top AI Program', category };
    case 'trending-now':
      return { tag: _t('Trending right now'), tagName: 'Trending right now', category };
    case 'recently-updated':
      return { tag: _t('Recently updated'), tagName: 'Recently Updated', category };
    default:
      return undefined;
  }
};

type MarketingStatusTagOptions = {
  // "Recently updated" is behind an experiment (CVR-2724), so callers must opt in after reading it.
  includeRecentlyUpdated?: boolean;
};

export const getMarketingStatusTagForSlug = (
  slug: string,
  { includeRecentlyUpdated = false }: MarketingStatusTagOptions = {}
): MarketingStatusTag | undefined => {
  const category = getMarketingTagSlugMap()[slug];
  if (category === 'recently-updated' && !includeRecentlyUpdated) {
    return undefined;
  }
  return getMarketingTagContent(category);
};
